<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات قیمت رژیم"
        >
          <b-form @submit.prevent>
            <b-row>

              <b-col
                class="mt-2"
                md="4"
                offset-md="4"
              >
                <b-row>

                  <b-col md="12">
                    <b-form-group
                      label="دوره"
                    >
                      <z-diet-duration v-model="Form.DietDurationId" />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      label="نوع"
                      label-for="DietType"
                    >
                      <v-select
                        v-model="Form.DietType"
                        dir="rtl"
                        :reduce="x => x.value"
                        label="text"
                        input-id="DietType"
                        :clearable="false"
                        :options="enums('DietType')"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col v-if="lang !== 'fa'" md="12">
                    <b-form-group
                        label="عنوان در گوگل پلی"
                        label-for="UniversalPackageId"
                    >
                      <b-form-input
                          id="UniversalPackageId"
                          v-model="Form.UniversalPackageId"
                          name="UniversalPackageId"
                          autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      label="مبلغ"
                    >
                      <b-input-group>
                        <b-input-group-prepend is-text>
                          تومان
                        </b-input-group-prepend>
                        <cleave
                          v-model="Form.Price"
                          class="form-control"
                          :raw="false"
                          :options="options"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      label="تخفیف"
                    >
                      <b-input-group>
                        <b-input-group-prepend is-text>
                          تومان
                        </b-input-group-prepend>
                        <cleave
                          v-model="Form.Discount"
                          class="form-control"
                          :raw="false"
                          :options="options"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <b-form-group class="mt-1">
                      <b-form-checkbox
                        v-model="Form.IsActive"
                        value="true"
                        class="custom-control-success"
                      >
                        برای کاربر نمایش داده شود؟
                      </b-form-checkbox>

                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group class="mt-1">
                      <b-form-checkbox
                        v-model="Form.ShowOnFirstView"
                        class="custom-control-success"
                      >
                        نمایش در اولین بازدید کاربر
                      </b-form-checkbox>

                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group class="mt-1">
                      <b-form-checkbox
                        v-model="isDietByPlan"
                        value="true"
                        class="custom-control-success"
                      >
                        فروش رژیم با ورزش
                      </b-form-checkbox>

                    </b-form-group>
                  </b-col>
                  <b-col v-if="isDietByPlan" md="12">
                    <b-form-group label="گروه ورزشی" class="mt-1">
                      <activity-group
                          ref="activityGroup"
                          v-model="Form.ActivityGroupId"
                          :multiple="false"
                          :clearable="true"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>

                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>

                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import ZDietDuration from '@/tools/dietduration.vue'
import ActivityGroup from "@/tools/activitygroup.vue";
import i18n from "@/libs/i18n";
import ZActivityGroup from "@/tools/activitygroup.vue";

export default {
  name: 'DietDurationPriceDetails',
  components: {
    ZActivityGroup,
    ZDietDuration,
    ActivityGroup,
  },
  data() {
    return {
      Form: {
        Id: null,
        Price: 0,
        DietId: null,
        DietDurationId: null,
        IsActive: true,
        ShowOnFirstView: false,
        Discount: 0,
        UniversalPackageId: '',
        ActivityGroupId: '',
      },
      options: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalScale: 4,
      },
      loading: false,
      isDietByPlan: false,
    }
  },
  computed: {
    lang() {
      return i18n.locale
    }
  },
  watch: {
    'Form.ActivityGroupId': {
      immediate: true,
      handler(val) {
        if (val !== '' && val !== null) this.isDietByPlan = true
      }
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.dietdurationprice.add
      if (this.$route.params.id) {
        url = this.$api.dietdurationprice.update
      }

      const form = JSON.parse(JSON.stringify(this.Form))
      form.Price = form.Price.replaceAll(',', '')
      form.Discount = form.Discount.replaceAll(',', '')

      this.loading = true
      this.$http.post(
        url, form,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.dietdurationprice.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
        })
    },
  },
}
</script>
